import {quitPlaque} from '/plaque/quit_plaque_window.js';

export function makePlaqueQuitToggle(plaque, message, messageCancel, messageConfirm) {
    plaque.quitToggle = false;
    plaque.addEventListener('click', (e)=>plaquePressQuitToggle(plaque, message, messageCancel, messageConfirm, e));
}

function plaquePressQuitToggle(plaque, message, messageCancel, messageConfirm, e) {
    if(e.target.id==='plaque') {
        if(!plaque.quitToggle) {
            plaque.quitToggle = true;
            quitPlaque(plaque, message, messageCancel, messageConfirm);
        } else if(plaque.quitToggle) {
            plaque.quitToggle = false;
            plaque.querySelector('#quit-plaque-window').remove();

            for(let plaqueChild of plaque.children) {
                plaqueChild.classList.remove('hidden-info');
            }
        }
    }
    
}